import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PlatformService } from 'src/app/shared/services/platform.service';

@Component({
  selector: 'app-wearables-modal',
  templateUrl: './wearables-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WearablesModalComponent {
  public showQr = false;

  constructor(
    public modal: NgbActiveModal,
    private platformService: PlatformService
  ) {}

  isPlatformIOS() {
    return this.platformService.IOS;
  }

  isPlatformAndroid() {
    return this.platformService.ANDROID;
  }

  toggleQrView() {
    this.showQr = true;
  }

  get platformImg() {
    if (this.isPlatformAndroid()) {
      return 'connect-google-fit.svg';
    } else if (this.isPlatformIOS()) {
      return 'connect-health.svg';
    } else {
      return 'connect-app.svg';
    }
  }
}
